/**
 * Init
 */
$(document).foundation();


/**
 * Scroll menu
 */
$(window).scroll(function() {
    var scroll = $(window).scrollTop(),
        header = $('#mainMenu'),
        top = $('#topTop');
    if (scroll >= 100) {
        header.addClass('header--scroll');
        top.addClass('back-to-top--scroll');
    }
    else {
        header.removeClass('header--scroll');
        top.removeClass('back-to-top--scroll');
    }
});


jQuery(document).ready(function( $ ) {
    var textSlider = $('#textSlider');

    textSlider.on('init', function(event, slick){
        var text = $('.text-wrapper[data-id=1]');
        // text.css('maxWidth', '100%');
        setTimeout(function(){
            text.css('maxWidth', '100%');
        }, 500);
    })
    textSlider.slick({
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 500
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        var dataId = $(slick.$slides[currentSlide]).data('index');
        var text = $('.brackets[data-id=' + dataId + ']');
        text.addClass('brackets--show');
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var dataId = $(slick.$slides[currentSlide]).data('index');
        var text = $('.brackets[data-id=' + dataId + ']');
        text.removeClass('brackets--show');
    });

    /**
     * Counter slider
     */
    var counterSlider = $('#counterSlider');
    counterSlider.slick({
        infinite: true,
        autoplaySpeed: 2000,
        arrows: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive:  [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    speed: 250
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 250
                }
            }
        ]
    });

    /**
     * Counter slider mobile
     */
    var counterSliderMobile = $('#counterSliderMobile');
    counterSliderMobile.slick({
        infinite: true,
        autoplaySpeed: 2000,
        arrows: false,
        speed: 400,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive:  [
            {
                breakpoint: 6000,
                settings: 'unslick'
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    speed: 250
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 250
                }
            }
        ]
    });

    $(window).resize(function(){
        counterSliderMobile.slick('resize');
    });



    // logoSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //     logoSlider.find('.slick-slide').addClass('slick-slide--hide');
    // });
    // logoSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
    //     logoSlider.find('.slick-slide').removeClass('slick-slide--hide');
    // });



    /**
     * Animacja counterów
     */

    if ($('#counter').length > 0) {
        var waypoint = new Waypoint({
            element: document.getElementById('counter'),
            handler: function(direction) {
                $('.counter:not(.counter--scrolled)').each(function() {
                    $(this).addClass('counter--scrolled');
                })
            },
            offset: '100%'
        })

        /**
         * Counter
         */
        $('.count-to').counterUp({
            delay: 10,
            time: 1000
        });
    }
});

/**
 * flip card
 *
 * conatinerClass {string} - klasa obracanych kart
 * openClass {string} - klasa otwartej karty
 * breakpoint {number} - breakpoint szerokości ekranu
 * dataAttrName {string} - atrybut data linku aktywującego
 */
flipCardAuto('product-box', 'product-box--open', 640, '40%');
flipCardManual('product-box', 'product-box--open', 'flip-target');

flipCardAuto('benefit-box', 'benefit-box--open', 640, '40%');

flipCardAuto('team-box', 'team-box--open', 640, '25%');


/**
 * Smooth scroll
 */

var menu = $('#mainMenu');

$('a.smooth-scroll')
    .click(function(event) {
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                var fromTop = target.offset().top;
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: fromTop
                }, 750, function() {
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                } else {
                    $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                };
            });
        }
        if ($(window).width() < 1025 && !$(this).hasClass("smooth-scroll--home")) {
            $('#burgerIcon').toggleClass('burger-icon--open');

            if (menu.is(':visible') == true) {
                menu.css('display','none');
            }
        }
    }
});



/**
 * Responsive menu icon
 */
var burger = $('#burgerIcon');

burger.click(function(){
    $(this).toggleClass('burger-icon--open');
});


$(window).resize(function(){
    burger.removeClass('burger-icon--open');
});


/**
 * Toggler - tekst about us
 */



 function textToggler(target, toggler) {
    $(target)
    .on('on.zf.toggler', function(e) {
        $(toggler).addClass('open');
    })
    .on('off.zf.toggler', function(e) {
        $(toggler).removeClass('open');
    });
}

textToggler('#textPanel', '#textPanelToggler');
textToggler('#submitPanel', '#submitPanelToggler');
textToggler('#listPanel', '#listPanelToggler');


/** toggle text po klinięciu w link menu */
$('a[data-toggler-target]').click(function(event) {
    var target = '#' + $(this).data('toggler-target');
    $(target).css('display', 'block').attr('aria-expanded', 'true');
    $(target + 'Toggler').addClass('open');
});

// /** toggle text po klinięciu w link menu */
// $('a[data-toggler-target]').click(function(event) {
//     var target = '#' + $(this).data('toggler-target');
//     $(target).css('display', 'block').attr('aria-expanded', 'true');
//     $(target + 'Toggler').addClass('open');
// });


// - Noel Delgado | @pixelia_me


var nodes  = document.querySelectorAll('ul.boxes li'),
    _nodes = [].slice.call(nodes, 0);

var getDirection = function (ev, obj) {
    var w = obj.offsetWidth,
        h = obj.offsetHeight,
        x = (ev.pageX - obj.offsetLeft - (w / 2) * (w > h ? (h / w) : 1)),
        y = (ev.pageY - obj.offsetTop - (h / 2) * (h > w ? (w / h) : 1)),
        d = Math.round( Math.atan2(y, x) / 1.57079633 + 5 ) % 4;

    return d;
};

var addClass = function ( ev, obj, state ) {
    var direction = getDirection( ev, obj ),
        class_suffix = "";

    obj.className = "";

    switch ( direction ) {
        case 0 : class_suffix = '-top';    break;
        case 1 : class_suffix = '-right';  break;
        case 2 : class_suffix = '-bottom'; break;
        case 3 : class_suffix = '-left';   break;
    }

    obj.classList.add( state + class_suffix, 'product-box' );
};

// bind events
_nodes.forEach(function (el) {
    el.addEventListener('mouseover', function (ev) {
        addClass( ev, this, 'in' );
    }, false);

    el.addEventListener('mouseout', function (ev) {
        addClass( ev, this, 'out' );
    }, false);
});



document.addEventListener('touchstart', handleTouchStart, false);
document.addEventListener('touchmove', handleTouchMove, false);

var xDown = null;
var yDown = null;

function handleTouchStart(evt) {
    xDown = evt.touches[0].clientX;
    yDown = evt.touches[0].clientY;
    // console.log(yDown);
};

function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
        return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs( yDiff ) > 0) {
        if ($(window).width() < 960) {
            var counterSliderMobile = $('#counterSliderMobile');
            if (counterSliderMobile.length > 0) {
                counterSliderMobile.slick('slickPlay');
            }
            var counterSlider = $('#counterSlider');
            if (counterSlider.length > 0) {
                counterSlider.slick('slickPlay');
            }
        }

    }
    /* reset values */
    xDown = null;
    yDown = null;
};


$(window).resize(function(){
    resizeSrcsetClass('.srcsetImg');
});

function resizeSrcsetClass(imgClass) {
    $(imgClass).each(function() {
        $(this).addClass('resized')
    })
}

$(document).ready(function() {
    $('.select2').select2({
        minimumResultsForSearch: -1,
        placeholder: ''
    });
});

$(document).ready(function() {
    $('.select2-countries').select2({
        placeholder: '',
        data: select2Countries
    });

    // $("#registerForm").validate();
    // $("#loginForm").validate();
});




var animCont = $('#slideAnimation');


$(document).ready(function() {
    if (animCont.length > 0) {
        var animList = {
            1: { class: '.animation__slide--01', show: false, timeout: 700 },
            2: { class: '.animation__slide--02', show: false, timeout: 900 },
            3: { class: '.animation__slide--03', show: false, timeout: 1100 },
            4: { class: '.animation__slide--04', show: false, timeout: 1300 },
            5: { class: '.animation__slide--05', show: true, timeout: 1700 },
            6: { class: '.animation__slide--06', show: true, timeout: 1900 },
            7: { class: '.animation__slide--07', show: true, timeout: 2100 },
            8: { class: '.animation__slide--05', show: false, timeout: 3900 },
            9: { class: '.animation__slide--06', show: false, timeout: 3900 },
            10: { class: '.animation__slide--07', show: false, timeout: 3900 },
            11: { class: '.animation__slide--01', show: true, timeout: 4000 },
            12: { class: '.animation__slide--02', show: true, timeout: 4050 },
            13: { class: '.animation__slide--03', show: true, timeout: 4100 },
            14: { class: '.animation__slide--04', show: true, timeout: 4150 },
        }
        slideAnimation(animList);
        setInterval( function(){ slideAnimation(animList); }, 5000 );
    }

    function slideAnimation(list) {
        for (var i = 1; i <= Object.keys(list).length; i++) {
            (function(i) {
                setTimeout(function(){
                    fadeSlide($(list[i].class), list[i].show);
                }, list[i].timeout);
            })(i);
        }
    }

    function fadeSlide(node, show) {
        if (show == true) {
            node.addClass('display');
        }
        else {
            node.removeClass('display');
        }
    }
});



$(document).ready(function() {
    var target = document.getElementById("clients");
    var options = {}; //Define options e.g. "option1" : "value1", etc.

    if (target != null) {
        var elem = new Foundation.Tabs($(target), options);

        $('.tabs-title').on("mouseover", function() {
            var other = document.getElementsByClassName("tabs-panel");
            $(other).each(function() {
                $(this).hide();
            });

            //Find the associated panel id.
            var panelId = $(this).find("a").attr("href").substring(1);
            var tabContents = document.getElementById(panelId);
            $(tabContents).show();
        });
    }

    $('#contactModal').on('open.zf.reveal', function(){
        var scrollOffset = $(window).scrollTop();
	});

    $('#contactModal').on('closed.zf.reveal', function(){
        var scrollOffset = $(window).scrollTop();
        setTimeout(function(){
			$('a[data-open="contactModal"]').blur();
            $(window).scrollTop(scrollOffset);
		}, 0);
    });
});
